export const PAGE_SIZE = 100;
export const PRECEDING_RECORDS_COUNT = 5;
